import { render, staticRenderFns } from "./MessageScreen.vue?vue&type=template&id=4b9e7c52&scoped=true&"
import script from "./MessageScreen.vue?vue&type=script&lang=js&"
export * from "./MessageScreen.vue?vue&type=script&lang=js&"
import style0 from "./MessageScreen.vue?vue&type=style&index=0&id=4b9e7c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e7c52",
  null
  
)

export default component.exports